import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 10, viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 9L5 5L1 1", stroke: "#041E39", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgArrowRight;
